export enum DailyKpiTransformation {
  percent = 'percent',
  thousand = 'thousand'
}

export enum ToolTipPositions {
  top = 'top',
  right = 'right',
  bottom = 'bottom',
  left = 'left'
}

export enum BorderSidePosition{
  right = 'right',
  left = 'left'
}
